// extracted by mini-css-extract-plugin
export default {"review_form":"AddReview_review_form__PAdI0","ratings":"AddReview_ratings__y9bIk","error":"AddReview_error__wNZMF"};